import React from 'react';
import { Form, Col, Row, Card, Accordion } from 'react-bootstrap';
import { Radio } from '@material-ui/core';
import { ORIGINAL_LEDMODULE_ID } from '../../../../../utils/constantFeatures';
import { BASIC_NOMINAL_DATA, NOMINAL_DATA, ADVANCED_NOMINAL_DATA } from '../../../../../utils/constantFeatures';

export default class LedmoduleInfo extends React.Component {

    openFileDialog() {
        document.getElementById("ledmoduleImageInput").click();
    }

    containsProp(names) {
        if (this.props.ledmodule && this.props.ledmodule.properties) {
            for (let i=0; i< this.props.ledmodule.properties.length; i++) {
                if (names.indexOf(this.props.ledmodule.properties[i].info.name) !== -1) {
                    return true;
                }
            }
        }
        return false;
    }

    render() {

        return (
            <Accordion defaultActiveKey="1" className="card-ledmodule-info">
                <Card>
                    <Row className="row-create-ledmodule">
                        <Form.Group as={Col} md="1" controlId="id" >
                            <Form.Label>LED Module ID</Form.Label>
                            <Form.Control
                                disabled
                                name="ledmoduleId"
                                type="text"
                                value={this.props.ledmodule.id !== ORIGINAL_LEDMODULE_ID ? this.props.ledmodule.id : '' }
                                onChange={this.props.handleChange}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="name" >
                            <Form.Label className="required" style={{ fontWeight: "700" }}>LED Module Name</Form.Label>
                            <Form.Control
                                required
                                name="ledmoduleName"
                                type="text"
                                value={this.props.ledmoduleName}
                                onChange={this.props.handleChange}
                                placeholder="LED Module name"
                                // isdanger={"" + !!this.props.errors.name}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="description">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                name="ledmoduleDescription"
                                type="text"
                                value={this.props.ledmoduleDescription}
                                onChange={this.props.handleChange}
                                placeholder="Description"
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="description">
                            <Row><Form.Label>Creation Mode</Form.Label></Row>
                            <Row>
                                <div>
                                    <Radio
                                        name="ledmoduleType"
                                        value="B"
                                        disabled={!this.containsProp([BASIC_NOMINAL_DATA.physicalColdest])}
                                        checked={this.props.ledmoduleType === 'B'}
                                        onClick={this.props.handleChange}
                                        onChange={this.props.handleChange} />Basic
                                </div>
                                <div>
                                    <Radio
                                        name="ledmoduleType"
                                        value="A"
                                        disabled={!this.containsProp([NOMINAL_DATA.moduleTemperatureAmbient])}
                                        checked={this.props.ledmoduleType === 'A'}
                                        onClick={this.props.handleChange}
                                        onChange={this.props.handleChange} />Advanced
                                </div>
                                <div>
                                    <Radio
                                        name="ledmoduleType"
                                        value="P"
                                        disabled={!this.containsProp([ADVANCED_NOMINAL_DATA.moduleTemperatureAmbient])}
                                        checked={this.props.ledmoduleType === 'P'}
                                        onClick={this.props.handleChange}
                                        onChange={this.props.handleChange} />Premium
                                </div>    
                            </Row>
                        </Form.Group>
                    </Row>
                </Card>
            </Accordion>
        )
    }
}